import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=4584b04e&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=ts"
export * from "./LoginLayout.vue?vue&type=script&lang=ts"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=4584b04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584b04e",
  null
  
)

export default component.exports